import { render } from "./DetailAnchor.vue?vue&type=template&id=cb5acaaa"
import script from "./DetailAnchor.vue?vue&type=script&lang=js"
export * from "./DetailAnchor.vue?vue&type=script&lang=js"

import exportComponent from "E:\\workspace\\moolng-cms-parent\\moolng-lunzhongyi-pc\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__